import { useMutation } from '@tanstack/react-query';

import { deleteUser } from '../api';

export const useDeleteUser = (onSuccess: () => Promise<void> | void) => {
  const mutation = useMutation({
    mutationFn: deleteUser,
    onSuccess: async () => {
      await onSuccess();
    },
  });

  return mutation;
};
